import { render } from "./FormParameterEditor.vue?vue&type=template&id=88c011ec&scoped=true&ts=true"
import script from "./FormParameterEditor.vue?vue&type=script&lang=ts"
export * from "./FormParameterEditor.vue?vue&type=script&lang=ts"

import "./FormParameterEditor.vue?vue&type=style&index=0&id=88c011ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c011ec"]])

export default __exports__